export const messages = {
  en: {
    integralGiftDetailManage: {
      search: {
        title: 'Search Conditions',
        detailId: 'Record ID',
        userNameLike: 'User Name',
        tel: 'Phone Number'
      },
      list: {
        title: 'Gift Records'
      },
      table: {
        detailId: 'Record ID',
        acctName: 'Account Name',
        configName: 'Standard Name',
        ruleName: 'Rule Name',
        quantity: 'Points Quantity',
        userName: 'User Name',
        tel: 'Phone Number',
        createTime: 'Gift Time'
      },
      fetchError: 'Failed to fetch gift records',
      page: {
        subtitle: 'Track points gift records issued to owners',
        empty: 'No gift record data',
        loadFailed: 'Failed to load gift record list'
      }
    }
  },
  zh: {
    integralGiftDetailManage: {
      search: {
        title: '查询条件',
        detailId: '记录编号',
        userNameLike: '用户名称',
        tel: '手机号'
      },
      list: {
        title: '赠送记录'
      },
      table: {
        detailId: '记录编号',
        acctName: '账户名称',
        configName: '标准名称',
        ruleName: '规则名称',
        quantity: '积分数量',
        userName: '用户名称',
        tel: '手机号',
        createTime: '赠送时间'
      },
      fetchError: '获取赠送记录失败',
      page: {
        subtitle: '追踪发放给业主的积分赠送记录',
        empty: '暂无赠送记录数据',
        loadFailed: '获取赠送记录列表失败'
      }
    }
  }
}